import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import TransiluminatorCaution from '@learningblocks/exp-constants/lib/Images/transiluminator-caution.svg';

export function Caution(props) {
  return (
    <Image
      src={TransiluminatorCaution}
      style={props.style}
      alt='transiluminator_caution'
    />
  );
}

Caution.propTypes = {
  /**
   * style to set on component
   */
  style: PropTypes.object,
};
